export default __webpack_public_path__ + "static/media/time-add.632c4da5.svg";